export default "/images/vendor/flag-icon-css/flags/1x1/ga.svg?dec832634c40be902627f39315558653";